import VehicleAggregate from './toll-ticket/vehicle-aggregate.vue'
import DateRoute from './toll-ticket/date-route.vue'
import SummaryAggregate from './toll-ticket/summary.vue'
import Tolls from '../../../../services/toll';
import * as F from '../../../../filters/date';
import {format, isAfter, isBefore} from "date-fns";
import TransportadorRntrc from "./toll-ticket/transportador-rntrc.vue";

export default {
  props: ['contractShipper'],
  data() {
    return {
      loading: undefined,
      step: 0,
      msgError: undefined,
      routeSelected: undefined,
      filterActive: true,
      aggregate: undefined,
      docEmbarqueNum: undefined,
      docEmbarqueTipo: undefined,
      forceTransfer: false,
      showForceTransfer: false,
      idIntern: undefined,
      confirmRouteSelected: false,
      expirationVP: undefined,
      startVP: undefined,
      transportadorRntrc: {documento:undefined, nome:undefined},
      showTranportadorRntrc: false,
    }
  },
  computed: {
    contractId(){
      return this.$route.params.contractId;
    },

  },
  watch: {
    filterActive(){
      this.filter()
    },
  },
  methods: {
    aggregateData(fn) {
      this.aggregate = fn;
    },
    callback(fn) {
      this.confirmRouteSelected = fn;
    },
    cleanErrors() {
      this.msgError = undefined;
    },
    nextStep() {
      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      switch (this.step) {
        case 0:
          this.step += 1;
          break;
        case 1:
          // VERIFICANDO SE FOI SELECIONADA UMA ROTA.
          if (this.routeSelected !== undefined) {
            this.step += 1;
            this.confirmRouteSelected = false;
            if (this.routeSelected.expirationToll)
              this.expirationVP = new Date(this.routeSelected.expirationToll);
            if (this.routeSelected.startToll)
              this.startVP = new Date(this.routeSelected.startToll);
            if (!this.expirationVP) {
              this.msgError = 'Informe a data de fim da viagem.';
              if (this.routeSelected !== undefined) this.step -= 1;
              return;
            }

            if (!this.startVP) {
              this.msgError = 'Informe a data de inicio da viagem.';
              if (this.routeSelected !== undefined) this.step -= 1;
              return;
            }

            const dateNow_30 = new Date();
            dateNow_30.setUTCDate(dateNow_30.getUTCDate() + 30);

            if (isAfter(this.expirationVP, dateNow_30)) {
              this.msgError = 'Data de fim da viagem deve ser anterior a ' + format(dateNow_30, 'yyyy-MM-dd HH:mm:ss') + '.';
              this.step -= 1;
              return;
            }

            if (isBefore(this.expirationVP, this.startVP)) {
              this.msgError = 'Data de fim da viagem deve ser superior a data de início da viagem.';
              this.step -= 1;
              return;
            }

          } else {
            this.confirmRouteSelected = true;
          }
          break;
        case 2:
          this.step += 1;
          break;
        case 3:
          this.step += 1;
          break;
      }
    },
    backStep() {
      this.msgError = undefined;
      if (this.step === 2)
        this.cleanVars();
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      this.step -= 1;
    },
    doRequest() {
      this.msgError = undefined;
      if(this.routeSelected.totalValue == 0){
         this.msgError = 'Ocorreu um problema, o valor total dos pedágios não pode ser ZERO';
         return;
      }

      let req = {
        placaVeiculo: this.aggregate.plate,
        routeId: this.routeSelected.routeId,
        version: this.routeSelected.version,
        // expirationVP: F.date(this.routeSelected.expirationToll, 'YYYY-MM-DD'),
        expirationVP: format(new Date(this.routeSelected.expirationToll), 'yyyy-MM-dd HH:mm:ss'),
        startVP: format(new Date(this.routeSelected.startToll), 'yyyy-MM-dd HH:mm:ss'),
        CNPJTransportador: this.transportadorRntrc.documento,
        transportador: this.transportadorRntrc.nome,
        docEmbarqueTipo: '',
        docEmbarqueNum: '',
        CPFCNPJEmbarcador: this.aggregate.taxIdNumber,
        categoryArtespId: this.aggregate.categoryAxesId,
        forceTransfer: this.forceTransfer ? 1 : 0,
        contratoOrig: this.contractShipper.contractId
      };

      this.loading = Tolls.insertValePedagio(req).then(res => {
        this.msgError = undefined;
        this.idIntern = res.idIntern;
        this.step += 1;

      }).catch(err => {
        this.msgError = err.data.status.message;
        if(err.data.status &&
          (
            err.data.status.code === 9203 ||
            err.data.status.code === 9205 ||
            err.data.status.code === 9209 ||
            err.data.status.code === 9210 ||
            err.data.status.code === 9223 ||
            err.data.status.code === 9225
          )
        ){
          this.showTranportadorRntrc = true
          this.enableRNTRC = true;
          this.step -= 1
          return ;
        }
        if(err.data.status && err.data.status.code == 500){
          this.showForceTransfer = true;
          return ;
        }
      });
    },
    closeModal() {
      let close = {
        modal: 'toll-ticket'
      };
      this.$emit('close', close);
      this.aggregateData = undefined;
      this.routeSelected = undefined;
      // this.routeSelected.expirationToll = undefined;
      this.transportadorRntrc= undefined;
      this.step = 0;
      this.msgError = undefined;
    },
    cleanVars() {
      this.expirationVP = undefined;
      this.routeSelected = undefined;
      this.msgError = undefined;
    }
  },
  components: {
    TransportadorRntrc, VehicleAggregate, DateRoute, SummaryAggregate
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/modal-toll-ticket.js